export const FREE_PLAN_TEAM_SEATS = 1;
export const PAID_PLAN_TEAM_SEATS = 5;

export const getTeamSeatLimit = (credits) => {
    if (!credits) {
        return FREE_PLAN_TEAM_SEATS;
    }
    return credits.isFreePlan ? FREE_PLAN_TEAM_SEATS : PAID_PLAN_TEAM_SEATS;
};


